
















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { MapOptions } from 'leaflet';
import { LMap, LTileLayer } from 'vue2-leaflet';

import { SettingsState } from '@/store';

// this Id is very important: click on the background is detected based on it.
// It used in clickOutside events with vue-outside directive
export const NETWORK_COMPONENT_ID = 's-map';

@Component({
    components: { LMap, LTileLayer },
})
export default class Network extends Vue {
    public zoom: number = 3;
    public url: string = 'https://a.tile.openstreetmap.org/{z}/{x}/{y}.png';
    public mapOptions: MapOptions = {
        zoomControl: false,
    };

    public get showMap(): boolean {
        const { global } = SettingsState.contextSettings;
        const value = global && global.showMap || false;

        if (typeof value === 'string') {
            return `${value}`.toLowerCase() === 'true';
        }

        return value;
    }

    public get componentId(): string {
        return NETWORK_COMPONENT_ID;
    }

}
